import web from "../web";

class InscriptionsService {
    index(token){
        return web.get("/api/inscriptions", { headers: { 'Authorization': 'Bearer '+token } })
    }
    getParents(token){
        return web.get("/api/parents", { headers: { 'Authorization': 'Bearer '+token } })
    } 
    getCivilites(token){
        return web.get("/api/civilites", { headers: { 'Authorization': 'Bearer '+token } })
    } 
    createParent(data, token){
        return web.post("/api/parents", data, { headers: { 'Authorization': 'Bearer '+token } })
    }
    createApprenant(data, token){
        return web.post("/api/apprenants", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    storeInscription(data, token){
        return web.post("/api/inscriptions", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    storeReinscription(data, token){
        return web.post("/api/inscriptions/reinscription", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    getDetailsInscrit(id, token){
        return web.get(`/api/inscriptions/${id}/show`, { headers: { 'Authorization': 'Bearer '+token } })
    }

    getDetailsApprenant(id, token){
        return web.get(`/api/apprenants/personnes/${id}/details`, { headers: { 'Authorization': 'Bearer '+token } })
    }

    getAnneeAcademique(token){
        return web.get("/api/anneesacademiques/current-year", { headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/inscriptions/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
    show(id,token){
        return web.get(`/api/inscriptions/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new InscriptionsService()